import mongoose from 'mongoose';
import schema, { IOwnershipTransferDocument } from '../schemas/ownership-transfer';

const OwnershipTransfer = (mongoose.models.OwnershipTransfer ||
  mongoose.model('OwnershipTransfer', schema)) as mongoose.Model<IOwnershipTransferDocument>;

export default OwnershipTransfer;
